import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import StarRatingoComponent from "../../atom/Buttons/StarRating";
import TextButtonComponet from "../../atom/Buttons/TextButton";
import { useNavigate } from "react-router-dom";
import { DurationButton, RadioButtonComponent } from "../../atom";
import { useSelector } from "react-redux";
import { APPROXIMATESIGN, DEFAULT_CURRENCY, getText, onGetCurrencySymble, THEME_COLORS, EXISTING_COURSE_STATUS } from "../../../core/Constant";
import moment from "moment";
import _ from "lodash";


const CourseMainCard = ({
  item,
  id = "",
  title = "",
  duration = "",
  price = "",
  durationtitle = "",
  pricetitle = "",
  coursename,
  description,
  paragraph,
  reviews,
  onCourseView,
  onEnroll,
  onFreeOrientation,
  width,
  image,
  rating,
  plans = [],
  isFree,
  onSampleClass = () => {},
  currency,
  isMultiBatch,
  onViewMore = ()=> {},
  plan,
  freeDescription = "",
  selectedCurrency
}) => {
  const navigate = useNavigate();
  const [isShow, setIsShow] = useState(0);

  const show = useSelector((state) => state.common.get("show"));
  const [selectedPlan, setSelectedPlan] = useState("");

  const isShowApproxiSign = selectedCurrency?.currency !== DEFAULT_CURRENCY
  
  const formattedPlans = plans?.map((plan) => ({
    label: plan?.plan_name || "",
    value: plan?.id,
    batch_month: plan?.batch_month || "",
    batch_year: plan?.batch_year || "",
  }))?.slice(0, 2);

  const getCurrency = (selectedPlan) => {
    if (selectedPlan) {
      const currencySymbol = onGetCurrencySymble(
        _.get(selectedPlan, "currency.currency"),
      );
      localStorage.setItem("GlobalCurrency", selectedPlan?.currency_id);
      return `${isShowApproxiSign && selectedPlan?.price ? APPROXIMATESIGN : ""}${currencySymbol}${selectedPlan?.price}`;
    } else {
      return "";
    }
  };


  useEffect(() => {
    setIsShow(show == 1);
  }, [show]);

  const handleRadioChange = (event) => {
    const text = getText(event);
    const selectedPlan = plans?.find((plan) => plan?.id?.toString() === text?.toString());
    setSelectedPlan(selectedPlan);
  };

  useEffect(()=>{
    if(plans?.length > 0){
      const selectedP = plans?.find((p)=> p?.id?.toString() === plan?.id?.toString())
      if(selectedP){
        setSelectedPlan(selectedP);
      } else {
       const selectedPlan = plans.reduce((min, current) =>
         current.duration_weeks < min.duration_weeks ? current : min
       );
       setSelectedPlan(selectedPlan);
      }
    } else {
      setSelectedPlan("");
    }
  },[plans, plan])

  const courseTitle = title || "";
  const courseNameNeedsTooltip = courseTitle?.length > 65;
  const courseNameDisplayedText = courseNameNeedsTooltip
   ? `${courseTitle?.substring(0, 65)}...`
   : courseTitle;

  return (
    <Card sx={{ maxWidth: 370, minWidth: 370, borderRadius: 6, display:"flex", flexDirection:"column" }}>
      <Box
        sx={{
          position: "relative",
          backgroundImage:
            "linear-gradient(to top, #2d3945, #292b34, #211e24, #161214, #000000)",
        }}
      >
        <CardMedia
          component="img"
          height="220"
          classes={{ img: "card-image-container" }}
          image={image}
          alt="Card-image"
          style={{ opacity: 0.9 }}
        />
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            color: "white",
            fontFamily: "'Saira Extra Condensed', sans-serif",
            fontWeight: 700,
            fontSize: 40,
            bottom: 0,
            left: 0,
            textShadow: 'rgba(0, 0, 0, 0.5) 0px 0px 10px',
            backgroundColor: "transparent",
            backgroundImage: "linear-gradient(180deg, #FFFFFF00 30%, #000000 100%)"

          }}
        >
          <span style={{ position: "absolute", bottom: 0, left: 20 }}>{
            <>
             {courseNameNeedsTooltip ? (
                <Tooltip title={courseTitle} placement="top" arrow>
                  <span style={{ cursor: "pointer" }}>
                    {courseNameDisplayedText}
                  </span>
                </Tooltip>
              ) : (
                courseNameDisplayedText
              )}
            </>
            }</span>
        </div>
      </Box>

      <CardContent>
        <Grid container flexDirection={"column"} spacing={3}>        
            <Grid item>
              <Grid
                container
                sx={{
                  bgcolor: THEME_COLORS.gray4,
                  borderRadius: 2,
                  height:"121px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems:"flex-start",
                  justifyContent:"flex-start"
                }}
              >
               {formattedPlans?.map((plan) => {
                 const planName = plan?.label || "";
                 const needsTooltip = planName?.length > 17;
                 const displayedText = needsTooltip
                    ? `${planName?.substring(0, 17)}...`
                    : planName;
                
                 const freeDesc = freeDescription || "";
                 const freeDescNeedsTooltip = freeDesc?.length > 175;
                 const freeDescDisplayedText = freeDescNeedsTooltip
                    ? `${freeDesc?.substring(0, 175)}...`
                    : freeDesc;
                
                 
                 return (
                   <Grid
                     item
                     xs={12}
                     key={plan?.value}
                     sx={{
                       height: "40px",
                       display: "flex",
                       alignItems: isFree === 1 ?  "flex-start" : "center",
                     }}
                   >
                    {
                      isFree === 0 ? (plan?.label || (plan?.batch_month && plan?.batch_year)) ? <RadioButtonComponent
                       checked={selectedPlan?.id === plan?.value}
                       value={plan?.value}
                       handleChange={handleRadioChange}
                     /> : null :  <RadioButtonComponent
                       checked={selectedPlan?.id === plan?.value}
                       value={plan?.value}
                       handleChange={handleRadioChange}
                     />
                    }
                     
                     <Box
                       sx={{
                         minWidth: 0,
                         flex: 1,
                         marginTop: isFree === 1 ? "9px" : "0px"
                       }}
                     >
                       <span
                         style={{
                           fontFamily: "Montserrat, sans-serif",
                           fontSize: "15px",
                           marginRight: 5,
                           color: "#2d3945",
                         }}
                       >
                        {
                          isFree === 1 ? <>
                          {freeDescNeedsTooltip ? (
                           <Tooltip title={freeDesc} placement="top" arrow>
                             <span style={{ cursor: "pointer" }}>
                               {freeDescDisplayedText}
                             </span>
                           </Tooltip>
                         ) : (
                           freeDescDisplayedText
                         )}
                          </> : <>
                        {needsTooltip ? (
                           <Tooltip title={planName} placement="top" arrow>
                             <span style={{ cursor: "pointer" }}>
                               {displayedText}
                             </span>
                           </Tooltip>
                         ) : (
                           displayedText
                         )}
                         </>
                        }
                       </span>
             
                       <span
                         style={{
                           fontFamily: "Montserrat, sans-serif",
                           fontWeight: 800,
                           fontSize: "15px",
                           color: "#2d3945",
                         }}
                       >
                         {plan?.label ?  "- " : ""}
                         {plan?.batch_month
                           ? moment()
                               .month(Number(plan.batch_month) - 1)
                               .format("MMMM")
                           : ""}{" "}
                         {plan?.batch_year || ""}
                       </span>
                     </Box>
                   </Grid>
                 );
               })}               
                 <Grid
                   item
                   xs={12}
                   sx={{
                     height: "40px",
                     display: "flex",
                     alignItems: "center",
                   }}
                 >
                  {
                    plans?.length > 2 && <Box
                     sx={{
                       pl: 2,
                       cursor: "pointer",
                     }}
                     onClick={() => onViewMore(selectedPlan)}
                   >
                     <Typography
                       component="span"
                       color={THEME_COLORS.primary}
                       fontWeight={700}
                       fontSize={16}
                     >
                       View More
                     </Typography>
                   </Box>
                  }
                 </Grid>
             </Grid>
           </Grid>
          
          <Grid item>
            <Grid container spacing={1}>
              <Grid item>
                {isShow ? (
                  <DurationButton
                    subtitle={
                      isFree === EXISTING_COURSE_STATUS.FREE ? (
                        <b>Free</b>
                      ) : isMultiBatch === EXISTING_COURSE_STATUS.FREE ? (
                        selectedPlan ? getCurrency(selectedPlan) : ""
                      ) : (
                        `${isShowApproxiSign && price ? APPROXIMATESIGN : ""}${price}`
                      )
                    }
                    title={pricetitle}
                  />
                ) : null}              
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid
              container
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Grid item>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignSelf: "center",
                    justifyContent: "center",
                    backgroundColor: "white",
                  }}
                >
                  <span style={{ fontFamily: "Montserrat", fontWeight: 500 }}>
                    {reviews < 10 ? "0" + reviews : reviews} Reviews
                  </span>
                  <StarRatingoComponent
                    readOnly
                    selectValue={rating}
                    size={"50"}
                  />
                </Box>
              </Grid>
              <Grid item>
                <TextButtonComponet
                  onButtonClick={()=> onCourseView(selectedPlan)}
                  classStyle={"btn btn-course"}
                  text={"View Course"}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container flexDirection={"column"} spacing={0.5}>
              <Grid item>
                <span
                  style={{
                    fontSize: 15,
                    fontWeight: 600,
                    fontFamily: "Montserrat",
                  }}
                >
                  {description}
                </span>
              </Grid>
              <Grid item height={70}>
                <span
                  style={{
                    fontSize: 15,
                    fontWeight: 500,
                    fontFamily: "Montserrat",
                    display: "-webkit-box",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    WebkitLineClamp: 4,
                    // lineHeight: "1rem",
                    maxHeight: "4.5rem",
                  }}
                  title={paragraph}
                >
                  {paragraph}
                </span>
              </Grid>
            </Grid>
          </Grid>
          
        </Grid>
      </CardContent>
      <CardActions
        sx={{
          p: "16px",
          mt: "auto",
          paddingBottom: "24px",
        }}
      >
        <Grid container spacing={1.5}>
          <Grid item sx={{ display: "flex", justifyContent: "center" }}>
            <TextButtonComponet
              width={width}
              onButtonClick={() => {
                if (selectedPlan) {
                  onEnroll(selectedPlan);
                } else {
                  onEnroll();
                }
              }}
              classStyle={"btn btn-enroll"}
              text="Enroll now"
            />
          </Grid>
          <Grid item sx={{ display: "flex", justifyContent: "center" }}>
            {/* {id ==   2 ? } */}
            {/* <TextButtonComponet
            width={width}
            onButtonClick={onFreeOrientation}
            classStyle={"btn btn-free"}
            text="Free Orientation"
          /> */}
            <TextButtonComponet
              width={width}
              onButtonClick={onSampleClass}
              classStyle={"btn btn-enroll btn-free"}
              text="Free sample class"
            />
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

export default CourseMainCard;
